import React from "react"
import Head from "next/head"
import CustomImage from "@/main/customImage"
import { Container, Card, Col, Row } from "react-bootstrap"

import MiscHeroImage from "@/main/miscHeroImage"
import MakeEnquiryForm from "@/forms/makeEnquiryForm"
import ContactDetails from "@/contact/contactDetails"
import OpeningHours from "@/contact/openingHours"
import OfficeMap from "@/contact/officeMap"

function ContactScreen() {
    const url = "https://webbjenkins.co.uk/contact/"
    const title = "Contact Us - Webb Jenkins"
    const description =
        "Have a property related query? Contact us remotely via email or phone, or visit our office in Ventnor and we will be happy to help."
    const imgUrl =
        "https://webb-jenkins-static-164679926.imgix.net/socials/webbjenkins-contact-social.jpg"
    const imgWidth = 1200
    const imgHeight = 630
    const imgAlt = "Webb Jenkins logo with contact us caption"

    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:width" content={imgWidth} />
                <meta property="og:image:height" content={imgHeight} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>

            <MiscHeroImage
                title="Contact us"
                subtitle={
                    "Reach out to us any time and we will do everything we can to help"
                }
                subtitle2={
                    <>
                        <CustomImage
                            src="https://webb-jenkins-static-164679926.imgix.net/icons/email-white.svg"
                            alt="Email icon"
                            height={16}
                            width={16}
                        />
                        <span className="ms-1 text-white">
                            propertyservices@webbjenkins.co.uk
                        </span>
                    </>
                }
                subtitle3={
                    <>
                        <CustomImage
                            src="https://webb-jenkins-static-164679926.imgix.net/icons/phone-white.svg"
                            alt="Phone icon"
                            height={16}
                            width={16}
                        />

                        <span className="ms-1 text-white">01983 856111</span>
                    </>
                }
                image="contact-phone.jpg"
                alt="Landline phone"
                position="bottom"
            />

            <Container fluid="md" className="p-0 card-overlap-2">
                <Row className="m-0">
                    <Col xs={12} xl={7} className="px-0">
                        <Card>
                            <Card.Body>
                                <Card.Title>
                                    <h2 className="text-center">
                                        Send us a message
                                    </h2>
                                </Card.Title>
                            </Card.Body>
                        </Card>
                        <MakeEnquiryForm />
                    </Col>
                    <Col xs={12} xl={4} className="p-0 ms-auto">
                        <Row className="m-0">
                            <ContactDetails />
                            <Card className="mt-5">
                                <Card.Body>
                                    <Card.Title>
                                        <h2 className="text-center">
                                            Opening hours
                                        </h2>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                            <OpeningHours />
                        </Row>
                    </Col>
                </Row>
                <Card className="mt-5">
                    <Card.Body>
                        <Card.Title>
                            <h2 className="text-center">Our office location</h2>
                        </Card.Title>
                    </Card.Body>
                </Card>
                <OfficeMap />
            </Container>
        </>
    )
}

export default ContactScreen
